import React, { useState, useEffect, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import ProductCard from '../common/ProductCard';
import LoadingSpinner from '../common/LoadingSpinner';
import SearchFilter from './SearchFilter';
import api from '../../utils/api';
import SEO from '../common/SEO';
import toast from 'react-hot-toast';

const ProductListing = () => {
  const [products, setProducts] = useState([]);
  const [initialLoading, setInitialLoading] = useState(true);
  const [isFetching, setIsFetching] = useState(false);
  const [searchParams] = useSearchParams();
  const [filters, setFilters] = useState({
    search: searchParams.get('search') || '',
    category: searchParams.get('category') || 'all',
    sortBy: 'newest',
    minPrice: '',
    maxPrice: '',
  });

  useEffect(() => {
    fetchProducts();
  }, [filters]);

  const fetchProducts = async () => {
    setIsFetching(true);
    try {
      const params = new URLSearchParams();
      if (filters.search) params.append('search', filters.search);
      if (filters.category && filters.category !== 'all') params.append('category', filters.category);
      if (filters.sortBy) params.append('sortBy', filters.sortBy);
      if (filters.minPrice) params.append('minPrice', filters.minPrice);
      if (filters.maxPrice) params.append('maxPrice', filters.maxPrice);

      const { data } = await api.get(`/products?${params}`);
      setProducts(Array.isArray(data) ? data : []);
    } catch (error) {
      toast.error('Failed to load products');
    } finally {
      setInitialLoading(false);
      setIsFetching(false);
    }
  };

  if (initialLoading) return <LoadingSpinner />;

  return (
    <div className="container mx-auto px-4 py-8">
      <SEO title="Explore Electronics & Tech Catalog" description="Shop top smartphones, laptops, audio gear and accessories at GadgetStore." />
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-bold text-gray-900">Our Products</h1>
        {isFetching && (
          <span className="text-xs font-semibold text-primary bg-indigo-50 px-3 py-1 rounded-full border border-indigo-100 animate-pulse">
            Updating results...
          </span>
        )}
      </div>

      {/* Filter Component - Stays permanently mounted so search input never loses focus */}
      <SearchFilter filters={filters} setFilters={setFilters} />

      {products.length === 0 ? (
        <div className="text-center py-16 bg-white rounded-xl shadow-sm border border-gray-100">
          <p className="text-gray-500 text-lg font-medium">No products found matching your criteria</p>
          <p className="text-gray-400 text-sm mt-1">Try clearing filters or searching for another term like "iPhone" or "Sony".</p>
        </div>
      ) : (
        <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 transition-opacity ${isFetching ? 'opacity-70' : 'opacity-100'}`}>
          {products.map((product) => (
            <ProductCard key={product._id} product={product} />
          ))}
        </div>
      )}
    </div>
  );
};

export default ProductListing;